import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePreviewImageStore = defineStore('previewImages', () => {
  const images = ref<{ [key: string]: { data: []; timestamp: string } }>({});

  return { images };
});
